import ArrowToRight from '../img/ArrowToRight.svg';
import BenefitsTable from './BenefitsTable';
import { useState } from 'react';

export default function PlanBenefitsModal({ plan, discount }) {
  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <>
      {plan ? (
        <>
          <div
            onClick={openModal}
            className=' text-white mt-1 hover:cursor-pointer flex'
          >
            <p className='hover:underline'>Check your plan benefits</p>
            {/* You have {plan} plan */}
            <div className='dark:bg-[#292929] dark:rounded-full flex items-center dark:p-2 dark:scale-75 relative dark:w-[25px] dark:h-[25px] dark:justify-center dark:items-center  dark:relative dark:left-1'>
              <div className='font-semibold text-xl relative bottom-[1px] no-underline hover:no-underline'>
                {'>'}
              </div>
            </div>
          </div>
          <BenefitsTable
            discount={discount}
            isOpen={isOpen}
            closeModal={closeModal}
            openModal={openModal}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
}
